// Formatting shared by the billing screens. Money comes from the server in USD with the EGP figure next to it.

export function usd(v) {
  return v == null ? "—" : `${Number(v).toFixed(2)} $`;
}

export function egp(v) {
  return v == null ? "" : `${Math.round(Number(v)).toLocaleString("en")} ج.م`;
}

export function day(iso) {
  return iso ? new Date(iso).toLocaleDateString("en-GB") : "—";
}

export function gb(bytes) {
  return (bytes / 1073741824).toFixed(bytes >= 10737418240 ? 0 : 1);
}

export const STATE_LABEL = { NONE: "بدون اشتراك", ACTIVE: "نشط", GRACE: "فترة سماح", SUSPENDED: "متوقف" };
export const STATE_SEVERITY = { NONE: "info", ACTIVE: "success", GRACE: "warning", SUSPENDED: "danger" };
export const REQUEST_LABEL = { PENDING: "قيد المراجعة", APPROVED: "مقبول", REJECTED: "مرفوض" };
export const REQUEST_SEVERITY = { PENDING: "warning", APPROVED: "success", REJECTED: "danger" };
export const TX_LABEL = { TOPUP: "شحن", SUBSCRIPTION: "اشتراك / تجديد", AUTO_RENEW: "تجديد تلقائي", UPGRADE: "زيادة", ADJUSTMENT: "تعديل من الإدارة", BONUS: "هدية شحن", CDN: "استهلاك الـ CDN", THEME: "شراء ثيم", MEETING: "ميتنج مباشر" };
